import iFrameResize from "iframe-resizer";

export default () => {
  document.querySelectorAll("iframe").forEach((iframe) => {
    iFrameResize.iframeResizer(
      {
        heightCalculationMethod: "lowestElement",
      },
      iframe,
    );
  });
};
